export const SET_TTS_DATA = 'SET_TTS_DATA';
export const SET_AUDIO_FILES = 'SET_AUDIO_FILES';
